import axios from '../../http'
import { handleGetRequestParams } from '../../common/js/util'

class XBOrderReturn {
  // xb确认退货
  postXBConfirmReturn(data) {
    const url = `/api/xb/refund/confirm`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb获取退货单所有数据
  getXBOrderReturnList(options) {
    let url = `/api/xb/refund/search?`
    url += handleGetRequestParams(options)
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb获取退单详情
  getXBOrderReturnDetail(refundCode) {
    const url = `/api/xb/refund/detail?refundCode=${refundCode}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb获取退单物流
  getXBOrderReturnExpress(refundCode) {
    const url = `/api/xb/refund/express/detail?refundCode=${refundCode}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb提交退货信息
  postXBSubmitInfo(data) {
    const url = `/api/xb/refund/info`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb取消退货
  postXBCancel(data) {
    const url = `/api/xb/refund/cancel`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb确认收款
  postXBReceivables(data) {
    const url = `/api/xb/refund/finish`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb获取物流信息
  getXBLogistics() {
    const url = `/api/common/express/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBOrderReturn;
